import { faCcVisa } from '@fortawesome/free-brands-svg-icons/faCcVisa';
import { faCcJcb } from '@fortawesome/free-brands-svg-icons/faCcJcb';
import { faCcDiscover } from '@fortawesome/free-brands-svg-icons/faCcDiscover';
import { faCcDinersClub } from '@fortawesome/free-brands-svg-icons/faCcDinersClub';
import { faCcAmex } from '@fortawesome/free-brands-svg-icons/faCcAmex';
import { faCcMastercard } from '@fortawesome/free-brands-svg-icons/faCcMastercard';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons/faCreditCard';

export enum Brand {
  'american express' = 'American Express',
  'diners club' = 'Diners Club',
  discover = 'Discover',
  jcb = 'JCB',
  mastercard = 'MasterCard',
  'union pay' = 'UnionPay',
  visa = 'Visa',
  unknown = 'Unknown'
}

export interface CardDetails {
  brand: keyof typeof Brand;
  expiryYear: number;
  expiryMonth: number;
  lastFour: string;
}

export const creditCardIconMapping: { [BrandName in keyof typeof Brand]: IconDefinition } = {
  'american express': faCcAmex,
  'diners club': faCcDinersClub,
  discover: faCcDiscover,
  jcb: faCcJcb,
  mastercard: faCcMastercard,
  'union pay': faCreditCard,
  unknown: faCreditCard,
  visa: faCcVisa
};
